import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import FormButton from '../../shared/formButton/FormButton';
import Authinput from '../AuthInput/AuthInput';
import s from './AuthForm.module.scss';
import {
  sendEmail,
  setNewPassword,
  signinOperation,
  signupOperation,
} from '../../../redux/auth/authOperations';
import { useLangContext } from '../../../context/LangProvider';
import { getValidationSchema } from '../helpers/validateAuthForms';
import { getInitialValues } from '../helpers/authFormInitialValues';
import { routes } from '../../../routes/mainRoutes';
import { getAuthFormTitle } from '../helpers/authFormTitle';

const AuthForm = ({ formOptions, errorData, matchUrl }) => {
  const dispatch = useDispatch();
  const { language } = useLangContext();

  const initialValues = useMemo(() => getInitialValues(matchUrl), [matchUrl]);
  const validationSchema = useMemo(
    () => getValidationSchema({ url: matchUrl, lang: language }),
    [language, matchUrl],
  );

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      const {
        email,
        password,
        sendEmail: sendEmailValue,
        newPassword,
      } = values;
      switch (matchUrl) {
        case routes.LOGIN:
          dispatch(signinOperation({ email: email.trim(), password }));
          break;
        case routes.REGISTER:
          dispatch(signupOperation({ email: email.trim(), password }));
          break;
        case routes.SEND_EMAIL:
          dispatch(sendEmail({ email: sendEmailValue.trim() }));
          break;
        case routes.RESET_PASSWORD:
          dispatch(setNewPassword(newPassword));
          break;
        default:
          break;
      }
    },
  });

  const { values, errors, touched, handleChange, handleSubmit } = formik;

  return (
    <form className={s.form} onSubmit={handleSubmit}>
      <h1 className={s.title}>{getAuthFormTitle({ matchUrl, language })}</h1>
      {formOptions.map(({ id, name, type }) => (
        <Authinput
          key={id}
          id={id}
          type={type}
          name={name}
          value={values[name]}
          label={language.authForm[name]}
          errorProp={errors[name] || errorData[name]}
          touchedProp={touched[name]}
          cbOnChange={handleChange}
        />
      ))}

      <FormButton>
        {matchUrl === routes.REGISTER
          ? language.authForm.signupButton
          : matchUrl === routes.LOGIN
          ? language.authForm.signinButton
          : language.authForm.sendEmailButton}
      </FormButton>
    </form>
  );
};

export default AuthForm;
